import React from "react";
import Button from "../utils/Button";
import useShopStore from "../store/useShopStore";
import { useEffect } from "react";

export default function DeleteButton(props) {
  const { deleteProduct, getProducts } = useShopStore((state) => state);

  const handleClick = () => {
    deleteProduct(props.id);
    getProducts();
  };

  

  return (
    <Button
      onClick={handleClick}
      style={{ backgroundColor: "red" }}
      type="button"
    >
      Delete Product
    </Button>
  );
}
